import { render, staticRenderFns } from "./PostAnswers.vue?vue&type=template&id=3fdf7d02&scoped=true"
import script from "./PostAnswers.vue?vue&type=script&lang=js"
export * from "./PostAnswers.vue?vue&type=script&lang=js"
import style0 from "./PostAnswers.vue?vue&type=style&index=0&id=3fdf7d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdf7d02",
  null
  
)

export default component.exports